import { z } from 'zod';

import { BreakStepsSchema } from './Break';
import { CardPatchSchema } from './Card';

// partial validation schemas for update messages, which may carry only the fields that changed

export const PartialUpdateStepSchema = z.object({
    breakInfo: z.object({
        currentStep: BreakStepsSchema,
    }),
});

export const PartialUpdateCardSchema = z.object({
    breakInfo: z.object({
        currentCardIndex: z.number().optional(),
        box: z
            .object({
                pack: z
                    .object({
                        // UpdateCard payloads may carry partial card patches, not full card objects.
                        cards: z.array(CardPatchSchema).optional(),
                    })
                    .optional(),
            })
            .optional(),
    }),
});

export type PartialUpdateStep = z.infer<typeof PartialUpdateStepSchema>;
export type PartialUpdateCard = z.infer<typeof PartialUpdateCardSchema>;
